import { inject } from 'inversify';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { IRepo, IRepoResponse } from '@core/repo';
import { appendToFormData, urlMaker } from '@core/utils';
import { bind } from '@infra/container';

import { CreateOrderErrorsMapper, CreateUserMapper } from '../mappers';
import { CreateUserDto } from '../dtos';

export type ICreateUserRepoResponse = IRepoResponse<200> | IRepoResponse<422, object> | IRepoResponse<400 | 500, string>;

export type ICreateUserRepo = IRepo<[CreateUserDto, string | number | undefined], ICreateUserRepoResponse>;

export const CreateUserRepoType = Symbol.for('CreateUserRepoType');

@bind(CreateUserRepoType)
export class CreateUserRepo implements ICreateUserRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(dto: CreateUserDto, id?: string | number) {
    try {
      const body = new FormData();
      const mappedBody = CreateUserMapper.toPersistence(dto);

      appendToFormData(mappedBody, body);

      const url = id ? urlMaker('/api/admin/client/update') : urlMaker('/api/admin/client/create');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 400) {
        if (result.data.errors.has_email) {
          return {
            status: 400 as 400,
            response: Object.values(result.data.errors).flat().join('. '),
          };
        }

        const errors = CreateOrderErrorsMapper.toDomain(result.data.errors);

        return {
          status: 422 as 422,
          response: errors,
        };
      } else {
        return {
          status: 400 as 400,
          response: 'Məlumatlar əldə edilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi.',
      };
    }
  }
}
